import { Request } from "@xt/xtbase";

const { XtAxios } = Request;
const URL = "/xt-redemption/";

export function get_etfDealPairList(config?) {
  return XtAxios.get(URL + "etf/dealPairList", config);
}

export function post_etfNetWorth(config?) {
  return XtAxios.post(URL + "etf/net-worth", null, config);
}

export function post_getEtfByTradeMarket(config?) {
  return XtAxios.post(URL + "etf/getEtfByTradeMarket", null, config);
}

export function get_orderV4BuyList(config?) {
  return XtAxios.get(URL + "order/v4/buy-list", config);
}

export function get_orderV4RedeemList(config?) {
  return XtAxios.get(URL + "order/v4/redeem-list", config);
}

export function getDealPairInfo({ dealPair }) {
  return XtAxios.get(URL + "etf/productInfo/" + dealPair);
}

export function getBalance(config) {
  return XtAxios.post(URL + "order/buy-sell-used-balance", config);
}

export function post_etfApply(config?) {
  return XtAxios.post(URL + "order/buy", null, config);
}

export function post_etfAtone(config?) {
  return XtAxios.post(URL + "order/redeem", null, config);
}
